export enum TemplateResolutionKey {
  SQUARE = '1:1',
  PORTRAIT_9_16 = '9:16',
}

export interface TemplateResolution {
  key: TemplateResolutionKey;
  label: string;
  width: number;
  height: number;
}

export const TEMPLATE_RESOLUTIONS: Record<TemplateResolutionKey, TemplateResolution> = {
  [TemplateResolutionKey.SQUARE]: {
    key: TemplateResolutionKey.SQUARE,
    label: '1:1 (1080×1080)',
    width: 1080,
    height: 1080,
  },
  [TemplateResolutionKey.PORTRAIT_9_16]: {
    key: TemplateResolutionKey.PORTRAIT_9_16,
    label: '9:16 (720×1280)',
    width: 720,
    height: 1280,
  },
};

export const TEMPLATE_RESOLUTION_LIST: TemplateResolution[] = Object.values(TEMPLATE_RESOLUTIONS);

export const DEFAULT_TEMPLATE_RESOLUTION = TEMPLATE_RESOLUTIONS[TemplateResolutionKey.SQUARE];

export const resolveTemplateResolution = (width: number, height: number): TemplateResolution =>
  TEMPLATE_RESOLUTION_LIST.find((r) => r.width === width && r.height === height) ?? DEFAULT_TEMPLATE_RESOLUTION;
